import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { AlgoliaAnalytics } from '@grandvisionhq/analytics';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import PromotionBlock from '../../PromotionBlock/PromotionBlock.js';
import { usePlpDatalayerEvents } from '../../utils/DataLayer/hooks/use-plp-datalayer-events.js';
import ProductListingGrid from '../ProductListingGrid/ProductListingGrid.js';
import ProductListingGridCell from '../ProductListingGridCell/ProductListingGridCell.js';
import { usePromoIndices } from './use-promo-indices.js';
import ProductBlock from '../../ProductBlock/containers/Algolia.js';

const ProductListingPage = ({ products , pageSize , pageNumber , promotionSmall , promotionBig , formatProductUrl , reimbursableLogos , forwardedQueryParams ,  })=>{
    const { getLabel  } = useIntl();
    const { addImpressionEvent , pushImpressionsToDatalayer , pushProductClickToDatalayer  } = usePlpDatalayerEvents();
    const { smallPromoIndex , bigPromoIndex  } = usePromoIndices(products.length, !!promotionSmall);
    const isSmallScreen = MediaQuery.useIsPhone();
    const onProductBlockClick = React.useCallback((product, index, handleSearchAnalytics)=>{
        handleSearchAnalytics(product.objectID, index);
        pushProductClickToDatalayer(product, index);
    }, []);
    const dividerLabel = `${getLabel('common.page')} ${pageNumber}`;
    const showPromos = products.length >= pageSize;
    React.useEffect(()=>{
        pushImpressionsToDatalayer();
    }, []);
    const augmentedProductList = React.useMemo(()=>{
        return products.reduce((result, product, index)=>{
            if (showPromos && !!promotionSmall && result.length === smallPromoIndex) {
                var ref;
                const smallPromoIdentifier = 'promo-small';
                var ref1;
                result.push(/*#__PURE__*/ React.createElement(ProductListingGridCell, {
                    key: smallPromoIdentifier,
                    isWide: isSmallScreen
                }, /*#__PURE__*/ React.createElement(PromotionBlock, swcHelpers.extends({}, promotionSmall, {
                    id: smallPromoIdentifier,
                    size: isSmallScreen ? 'large' : 'small',
                    ctaLabel: (ref1 = (ref = promotionSmall.links) === null || ref === void 0 ? void 0 : ref.label) !== null && ref1 !== void 0 ? ref1 : ''
                }))));
            }
            if (showPromos && !!promotionBig && result.length === bigPromoIndex) {
                var ref2;
                const bigPromoIdentifier = 'promo-big';
                var ref3;
                result.push(/*#__PURE__*/ React.createElement(ProductListingGridCell, {
                    key: bigPromoIdentifier,
                    isWide: true
                }, /*#__PURE__*/ React.createElement(PromotionBlock, swcHelpers.extends({}, promotionBig, {
                    id: bigPromoIdentifier,
                    size: "large",
                    ctaLabel: (ref3 = (ref2 = promotionBig.links) === null || ref2 === void 0 ? void 0 : ref2.label) !== null && ref3 !== void 0 ? ref3 : ''
                }))));
                result.push(null);
            }
            result.push(/*#__PURE__*/ React.createElement(ProductListingGridCell, {
                key: product.masterVariant.sku
            }, /*#__PURE__*/ React.createElement(AlgoliaAnalytics, null, (handleSearchAnalytics)=>{
                 return React.createElement(ProductBlock, {
                    className: "product-listing-product-block",
                    product: product,
                    formatProductUrl: formatProductUrl,
                    onClick: ()=>onProductBlockClick(product, index, handleSearchAnalytics)
                    ,
                    reimbursableLogos: reimbursableLogos,
                    additionalUrlParams: forwardedQueryParams,
                    onImpression: ()=>{
                        return addImpressionEvent === null || addImpressionEvent === void 0 ? void 0 : addImpressionEvent(product, index);
                    }
                });
            })));
            return result;
        }, []);
    }, [
        products,
        showPromos,
        promotionSmall,
        smallPromoIndex,
        promotionBig,
        bigPromoIndex,
        isSmallScreen,
        formatProductUrl,
        reimbursableLogos,
        forwardedQueryParams,
        addImpressionEvent,
        onProductBlockClick, 
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": `product-listing-page-${pageNumber}`,
        className: classnames('product-listing-page', {
            'product-listing-page--with-divider': pageNumber !== 1
        })
    }, pageNumber !== 1 && /*#__PURE__*/ React.createElement("div", {
        className: "product-listing-page__divider"
    }, dividerLabel), /*#__PURE__*/ React.createElement(ProductListingGrid, {
        hasSmallPromo: showPromos && !!promotionSmall,
        hasBigPromo: showPromos && !!promotionBig
    }, augmentedProductList));
};
var ProductListingPage$1 = ProductListingPage;

export { ProductListingPage, ProductListingPage$1 as default };
//# sourceMappingURL=ProductListingPage.js.map
